import Vue from 'vue'
import Router from 'vue-router'

import Register from '@/pages/auth/register'
import Login from '@/pages/auth/login'
import Evpi from '@/pages/auth/evpi'
import AccountRegisterProtocol from '@/pages/auth/account-register-protocol'
import ChoiceOfStatus from '@/pages/auth/choice-of-status'
import PersonalInformation from '@/pages/auth/personal-information'
import UploadFile from '@/pages/auth/upload-file'
import Experience from '@/pages/auth/personal-experience'
import Coaching from '@/pages/auth/coaching-experience'
import ContactInformation from '@/pages/auth/contact-information'
import Review from '@/pages/auth/review'
import Order from '@/pages/auth/order'
import Hockey from '@/pages/auth/hockey'
import ContactHockey from '@/pages/auth/contact-hockey'
import MemershipExpired from '@/pages/auth/membership-expired'
import ForgetPassword from '@/pages/auth/forget-password'

import Ucenter from '@/pages/ucenter'
import ChangePassword from '@/pages/ucenter/change-password'
import ShowPlayer from '@/pages/ucenter/show-player'
import ShowCoach from '@/pages/ucenter/show-coach'
import TeamManagement from '@/pages/ucenter/team-manmagement'
import CreateTeamNull from '@/pages/ucenter/create-team-null'
import CreateTeam from '@/pages/ucenter/create-team'
import TeamList from '@/pages/ucenter/team-list'
import MatchEnroll from '@/pages/ucenter/match-enroll'
import SelectGroup from '@/pages/ucenter/select-group'
import ReplacePhone from '@/pages/ucenter/replace-phone'
import MatchList from '@/pages/ucenter/match-list'
import ScoreList from '@/pages/ucenter/score-list'
import Standings from '@/pages/ucenter/standings'
import TopScorerList from '@/pages/ucenter/top-scorer-list'
import CoachList from '@/pages/ucenter/coach-list'
import PlayerCareer from '@/pages/ucenter/player-career'
import IdentityProtocol from '@/pages/auth/identity-protocol'
import TeamSignUp from '@/pages/ucenter/team-sign-up'
import TeamManage from '@/pages/ucenter/team-manage'
import TeamDetailedRevise from '@/pages/ucenter/team-detailed-revise'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/register',
      name: 'Register',
      meta: {
        title: '会员注册'
      },
      component: Register
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '会员登录'
      },
      component: Login
    },
    {
      path: '/evpi',
      name: 'Evpi',
      meta: {
        title: '完善信息'
      },
      component: Evpi
    },
    {
      path: '/account-protocol',
      name: 'AccountProtocol',
      meta: {
        title: '账号注册协议'
      },
      component: AccountRegisterProtocol
    },
    {
      path: '/status',
      name: 'Status',
      meta: {
        title: '选择身份'
      },
      component: ChoiceOfStatus
    },
    {
      path: '/info',
      name: 'Info',
      meta: {
        title: '基本信息'
      },
      component: PersonalInformation
    },
    {
      path: '/upload-file',
      name: 'UploadFile',
      meta: {
        title: '上传证件'
      },
      component: UploadFile
    },
    {
      path: '/personal-experience',
      name: 'Experience',
      meta: {
        title: '个人经验'
      },
      component: Experience
    },
    {
      path: '/coaching-experience',
      name: 'Coaching',
      meta: {
        title: '执教经验'
      },
      component: Coaching
    },
    {
      path: '/contact-information',
      name: 'Contact',
      meta: {
        title: '联系方式'
      },
      component: ContactInformation
    },
    {
      path: '/review',
      name: 'Review',
      meta: {
        title: '提交审核'
      },
      component: Review
    },
    {
      path: '/order',
      name: 'Order',
      meta: {
        title: '订单详情'
      },
      component: Order
    },
    {
      path: '/ucenter',
      name: 'Ucenter',
      meta: {
        title: '会员中心'
      },
      component: Ucenter
    },
    {
      path: '/change-password',
      name: 'ChangePassword',
      meta: {
        title: '设置密码'
      },
      component: ChangePassword
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      meta: {
        title: '忘记密码'
      },
      component: ForgetPassword
    },
    {
      path: '/hockey',
      name: 'Hockey',
      meta: {
        title: '冰球水平'
      },
      component: Hockey
    },
    {
      path: '/contact-hockey',
      name: 'ContactHockey',
      meta: {
        title: '联系方式'
      },
      component: ContactHockey
    },
    {
      path: '/show-player',
      name: 'ShowPlayer',
      meta: {
        title: '旗下运动员'
      },
      component: ShowPlayer
    },
    {
      path: '/show-coach',
      name: 'ShowCoach',
      meta: {
        title: '旗下教练员'
      },
      component: ShowCoach
    },
    {
      path: '/team-manmagement',
      name: 'TeamManagement',
      meta: {
        title: '球队管理'
      },
      component: TeamManagement
    },
    {
      path: '/create-team-null',
      name: 'CreateTeamNull',
      meta: {
        title: '球队状态列表'
      },
      component: CreateTeamNull
    },
    {
      path: '/create-team',
      name: 'CreateTeam',
      meta: {
        title: '创建球队'
      },
      component: CreateTeam
    },
    {
      path: '/team-list',
      name: 'TeamList',
      meta: {
        title: '球队列表'
      },
      component: TeamList
    },
    {
      path: '/match-enroll',
      name: 'MatchEnroll',
      meta: {
        title: '球队报名'
      },
      component: MatchEnroll
    },
    {
      path: '/select-group',
      name: 'SelectGroup',
      meta: {
        title: '选择组别'
      },
      component: SelectGroup
    },
    {
      path: '/replace-phone',
      name: 'ReplacePhone',
      meta: {
        title: '手机换绑'
      },
      component: ReplacePhone
    },
    {
      path: '/membership-expired',
      name: 'MembershipExpired',
      meta: {
        title: '会员过期'
      },
      component: MemershipExpired
    },
    {
      path: '/match-list',
      name: 'MatchList',
      meta: {
        title: '赛事列表'
      },
      component: MatchList
    },
    {
      path: '/score-list',
      name: 'ScoreList',
      meta: {
        title: '成绩榜单'
      },
      component: ScoreList
    },
    {
      path: '/standings',
      name: 'Standings',
      meta: {
        title: '积分榜'
      },
      component: Standings
    },
    {
      path: '/top-scorer-list',
      name: 'TopScorerList',
      meta: {
        title: '射手榜'
      },
      component: TopScorerList
    },
    {
      path: '/player-career',
      name: 'PlayerCareer',
      meta: {
        title: '我的冰球生涯'
      },
      component: PlayerCareer
    },
    {
      path: '/coach-list',
      name: 'CoachList',
      meta: {
        title: '旗下教练员'
      },
      component: CoachList
    },
    {
      path: '/identity-protocol',
      name: 'IdentityProtocol',
      meta: {
        title: '身份注册信息'
      },
      component: IdentityProtocol
    },
    {
      path: '/team-sign-up',
      name: 'TeamSignUp',
      meta: {
        title: '球队报名'
      },
      component: TeamSignUp
    },
    {
      path: '/team-manage',
      name: 'TeamManage',
      meta: {
        title: '球队管理'
      },
      component: TeamManage
    },
    {
      path: '/team-detailed-revise',
      name: 'TeamDetailedRevise',
      meta: {
        title: '球队详情'
      },
      component: TeamDetailedRevise
    },
    { path: '*', redirect: '/ucenter' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js